export const statusNames = {pending: "wartet auf Prüfung", rejected: "abgelehnt", approved: "freigegeben"};
